//FIXME ...
// tslint:disable: no-commented-code
// tslint:disable: jsdoc-format
// tslint:disable: member-ordering
// tslint:disable: member-access
// tslint:disable: interface-name
// tslint:disable: no-consecutive-blank-lines
// tslint:disable: arrow-parens
// tslint:disable: typedef
// tslint:disable: prefer-immediate-return
// tslint:disable: typedef
// tslint:disable: prefer-const
// tslint:disable: max-classes-per-file
// tslint:disable: cognitive-complexity
// tslint:disable: object-literal-sort-keys
// tslint:disable: forin
// tslint:disable: max-line-length
// tslint:disable: semicolon
// tslint:disable: no-trailing-whitespace
// tslint:disable: no-console
// tslint:disable: prefer-template
// tslint:disable: prefer-conditional-expression
// tslint:disable: no-redundant-boolean
// tslint:disable: no-collapsible-if        
// tslint:disable: no-shadowed-variable
/**
 * @author Ivan Toth.
 */
var DetailSearchSubmitController = (function () {
    function DetailSearchSubmitController(topic, $state, $stateParams, env, searchSubmit, notify, socket, settings, $timeout, $http, moment) {
        this.topic = topic;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.env = env;
        this.searchSubmit = searchSubmit;
        this.notify = notify;
        this.socket = socket;
        this.settings = settings;
        this.$timeout = $timeout;
        this.$http = $http;
        this.moment = moment;
        this.dcLock = 'dc';
        this.OPP_VERSION_5 = 5;
        this.activeTab = $state.current.name;
        this.id = this.$stateParams.id;
        if (angular.isUndefined(this.searchSubmit.original) || angular.isUndefined(this.searchSubmit.original.table)) {
            this.finishUp();
        }
        this.tableData = this.searchSubmit.type === 'dc_v5' ?
            this.extractDcV5(this.searchSubmit.original.table) :
            this.searchSubmit.original.table;
        this.original_filter = {};
        this.searchCriteria = false;
        this.showSecondary = false;
    }
    DetailSearchSubmitController.prototype.$onInit = function () {
        var _this = this;
        // Scroll to top
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        if (!this.searchSubmit.original) {
            this.finishUp();
            return;
        }
        // Fill the all results - original & To be saved - results objects
        this.original_filter = {
            searchTxt: '',
            notEmpty: false,
            calculated: false,
            filters: {}
        };
        this.original_array = angular.copy(this.tableData);
        this.results_filter = {
            searchTxt: '',
            notEmpty: false,
            calculated: false,
            filters: {}
        };
        this.results_array = angular.copy(this.searchSubmit.results.table);
        // Prepare filter objects
        if (this.tableData.length > 0) {
            this.original_filter.notEmpty = true;
            this.results_filter.notEmpty = true;
            angular.forEach(this.tableData, function (arr) {
                for (var prop in arr) {
                    _this.original_filter.filters[prop] = { unique: [], picked: [], type: 's', cond: '=' };
                    _this.results_filter.filters[prop] = { unique: [], picked: [], type: 's', cond: '=' };
                }
            });
            this.makeFilterOptions('original');
            this.makeFilterOptions('results');
            this.original_filter.calculated = false;
            this.results_filter.calculated = false;
        }
        var tempArray = [];
        this.rowOrder = [];
        this.dropRowOrder = [];
        var mainCols = [];
        var secondCols = [];
        //Create columns for the tables
        if (angular.isDefined(this.searchSubmit.original.colVer)) {
            angular.forEach(this.settings.allColumnOrder, function (columnOrder) {
                angular.forEach(columnOrder.ds, function (ds) {
                    if (ds === _this.searchSubmit.original.ds) {
                        mainCols = columnOrder[_this.searchSubmit.original.colVer].main;
                        secondCols = columnOrder[_this.searchSubmit.original.colVer].second;
                    }
                });
            });
            angular.forEach(mainCols, function (columns) {
                tempArray.push(columns);
                _this.columnObj = (angular.isDefined(_this.settings.columnNames[_this.searchSubmit.type][columns])) ? _this.settings.columnNames[_this.searchSubmit.type][columns] : { h: columns };
                _this.columnObj.v = columns;
                if (_this.columnObj.t && _this.columnObj.t.indexOf('collapse') > -1) {
                    _this.dropRowOrder.push(_this.columnObj);
                    _this.showSecondary = true;
                }
                else {
                    _this.rowOrder.push(_this.columnObj);
                }
            });
            angular.forEach(secondCols, function (columns) {
                _this.columnObj = (angular.isDefined(_this.settings.columnNames[_this.searchSubmit.type][columns])) ? _this.settings.columnNames[_this.searchSubmit.type][columns] : { h: columns };
                _this.columnObj.v = columns;
                _this.dropRowOrder.push(_this.columnObj);
            });
            if (this.dropRowOrder.length > 0) {
                this.showSecondary = true;
            }
        }
        if (["MYSA_DUP", "SC_DUP"].includes(this.searchSubmit.original.ds) && !this.tableData.length) {
            tempArray = [];
            for (var prop in this.settings.columnNames[this.searchSubmit.type]) {
                this.columnObj = (angular.isDefined(this.settings.columnNames[this.searchSubmit.type][prop])) ? this.settings.columnNames[this.searchSubmit.type][prop] : { h: prop };
                this.columnObj.v = prop;
                if (this.columnObj.t && this.columnObj.t.indexOf('collapse') > -1) {
                    this.dropRowOrder.push(this.columnObj);
                    this.showSecondary = true;
                }
                else {
                    this.rowOrder.push(this.columnObj);
                }
            }
        }
        // Create columns for the columns, that are not listed in  cloudant
        if (this.tableData.length > 0) {
            //console.info(this.searchSubmit.original.table[0], '2');
            for (var prop in this.tableData[0]) {
                var found = true;
                if (mainCols.indexOf(prop) > -1 || secondCols.indexOf(prop) > -1 || prop === '$$hashKey' || prop === 'gov' || prop === 'unk' || prop === 'cmrDuns' || prop === '') {
                    found = false;
                }
                if (found) {
                    tempArray.push(prop);
                    this.columnObj = (this.settings.columnNames[this.searchSubmit.type] && this.settings.columnNames[this.searchSubmit.type][prop]) ? this.settings.columnNames[this.searchSubmit.type][prop] : { h: prop };
                    this.columnObj.v = prop;
                    if (this.columnObj.t && this.columnObj.t.indexOf('collapse') > -1) {
                        this.dropRowOrder.push(this.columnObj);
                        this.showSecondary = true;
                    }
                    else {
                        this.rowOrder.push(this.columnObj);
                    }
                }
            }
            // THis makes sure, that dropdowns have empty values
            this.original_countDrop = [];
            this.results_countDrop = [];
            for (var i = 0; i < this.rowOrder.length; i++) {
                this.original_countDrop[i] = 0;
                this.results_countDrop[i] = 0;
            }
            this.filterArray = angular.copy(tempArray);
        }
    };
    DetailSearchSubmitController.prototype.extractDcV5 = function (duplicateData) {
        if (!duplicateData) {
            return;
        }
        var inboundIncentiveDetail = _.get(this.topic.checksData, 'inbound.inbound.incentiveInformation.incentiveDetail');
        var inboundDealRegs = inboundIncentiveDetail.dealRegs;
        var result = [];
        // order of properties defines order of columns in the table
        var _loop_1 = function(duplicate) {
            var inboundDealReg = inboundDealRegs.find(function (item) { return item.dealRegGroupId === duplicate.drpgId; });
            var sviSubmitDateFormatted = duplicate.sviSubmitDate ? this_1.moment.utc(Number(duplicate.sviSubmitDate)).format('LLL') : '';
            var sviExpDate = duplicate.sviExpDate ? this_1.moment.utc(Number(duplicate.sviExpDate)).format('LLL') : '';
            var row = {
                opp: duplicate.opp,
                bpName: duplicate.bpName,
                sviSubmitDate: sviSubmitDateFormatted,
                sviExpDate: sviExpDate,
                country: duplicate.country,
                sviOverallStatus: duplicate.sviOverallStatus,
                ssaDup: duplicate.ssaDup ? duplicate.ssaDup : 'N',
                eiDup: duplicate.eiDup ? duplicate.eiDup : 'N',
                accountName: duplicate.accountName,
                drpgId: duplicate.drpgId,
                drpgName: inboundDealReg.dealRegGroupDescription
            };
            result.push(row);
        };
        var this_1 = this;
        for (var _i = 0, duplicateData_1 = duplicateData; _i < duplicateData_1.length; _i++) {
            var duplicate = duplicateData_1[_i];
            _loop_1(duplicate);
        }
        return result;
    };
    DetailSearchSubmitController.prototype.showGov = function () {
        this.original_filter.filters.gov.picked = [true];
        this.results_filter.filters.gov.picked = [true];
        this.original_filter.filters.unk.picked = [];
        this.results_filter.filters.unk.picked = [];
        this.blurFilterPick('original');
        this.blurFilterPick('results');
    };
    DetailSearchSubmitController.prototype.showUnk = function () {
        this.original_filter.filters.gov.picked = [];
        this.results_filter.filters.gov.picked = [];
        this.original_filter.filters.unk.picked = [true];
        this.results_filter.filters.unk.picked = [true];
        this.blurFilterPick('original');
        this.blurFilterPick('results');
    };
    DetailSearchSubmitController.prototype.cancelGoe = function () {
        this.original_filter.filters.gov.picked = [];
        this.results_filter.filters.gov.picked = [];
        this.original_filter.filters.unk.picked = [];
        this.results_filter.filters.unk.picked = [];
        this.blurFilterPick('original');
        this.blurFilterPick('results');
    };
    DetailSearchSubmitController.prototype.goto = function (tab) {
        this.$state.go(tab.name, this.$stateParams);
        this.topic.setActiveTab(tab.name);
        this.activeTab = tab.name;
    };
    /**
      Adds the filtered results
      @param source    source of the search
      @returns void
    */
    DetailSearchSubmitController.prototype.addFiltered = function (source) {
        var _this = this;
        var srcArr = source + '_array';
        angular.forEach(this[srcArr], function (arrayItem) {
            _this.addItem(arrayItem);
        });
    };
    /**
      Removes the filtered results
      @param source    source of the search
      @returns void
    */
    DetailSearchSubmitController.prototype.removeFiltered = function (source) {
        var _this = this;
        var srcArr = source + '_array';
        angular.forEach(this[srcArr], function (arrayItem) {
            _this.removeItem(arrayItem);
        });
    };
    /**
      Toggles the table row, when it contains a secondary row as a table
      @param rowObj    row to be toggled
      @returns void
    */
    DetailSearchSubmitController.prototype.toggleRow = function (rowObj) {
        if (angular.isDefined(rowObj.visible) && rowObj.visible) {
            rowObj.visible = false;
        }
        else {
            rowObj.visible = true;
        }
    };
    /**
      Toggle Searched criteria that was used to get this search
      @returns void
    */
    DetailSearchSubmitController.prototype.toggleCriteria = function () {
        this.searchCriteria = (this.searchCriteria) ? false : true;
    };
    /**
      Submit the saved results on the Save button press
      @returns void
    */
    DetailSearchSubmitController.prototype.submitResults = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'updateSearchResults',
                script: '/detail/eligibility/eligibility',
                results: {
                    saved: this.searchSubmit.results,
                    allResults: this.searchSubmit.original
                },
                type: this.searchSubmit.type,
                token: this.env.user.token,
                opp: this.topic.topic._id,
                bID: this.topic.topicBrowserID,
                partial: true
            }
        });
        this.searchSubmit.updateResults(undefined);
        this.searchSubmit.updateOriginal(undefined);
        this.searchSubmit.updateLaterProcess(false);
        this.finishUp();
    };
    /**
      Action to be performed on Cancel search
      @returns void
    */
    DetailSearchSubmitController.prototype.cancelResults = function () {
        this.topic.calculateAccess([this.searchSubmit.type], false);
        this.notify.success('Search results save cancelled');
        this.searchSubmit.updateResults(undefined);
        this.searchSubmit.updateOriginal(undefined);
        this.searchSubmit.updateLaterProcess(false);
        this.finishUp();
    };
    /**
      Add a item into the saved results table
      @param item    item to be added
      @returns void
    */
    DetailSearchSubmitController.prototype.addItem = function (item) {
        if (this.searchSubmit.addItem(item)) {
            this.results_filter.calculated = false;
            this.blurFilterPick('results');
            this.makeFilterOptions('results');
            this.results_filter.calculated = false;
        }
    };
    /**
      Remove a item from the saved table
      @param item    item to be added
      @returns void
    */
    DetailSearchSubmitController.prototype.removeItem = function (item) {
        if (this.searchSubmit.removeItem(item)) {
            this.results_filter.calculated = false;
            this.blurFilterPick('results');
            this.makeFilterOptions('results');
            this.results_filter.calculated = false;
        }
    };
    /**
      This will save the result in the browser & you can click it any time to open it again
      @returns void
    */
    DetailSearchSubmitController.prototype.processLaterResults = function () {
        this.topic.calculateAccess([this.searchSubmit.type], false);
        this.searchSubmit.updateLaterProcess(true);
        this.finishUp();
    };
    /**
      Export report into Excel file
      @returns void
    */
    DetailSearchSubmitController.prototype.excelExport = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'searchExportExcel',
                script: '/detail/eligibility/eligibility',
                data: this.searchSubmit.original,
                token: this.env.user.token
            }
        });
    };
    /**
      Clears the selected filter
      @param filtName     name of the filter
      @param source       original or results
      @returns void
    */
    DetailSearchSubmitController.prototype.clearFilter = function (filtName, source) {
        var src = source + '_filter';
        this[src].filters[filtName].picked = [];
        this.blurFilterPick(source);
    };
    /**
      Clicked / selected a item in the filter select, this will ensure, that the table will be recalculated when dropdown closes
      @param source       original or results
      @returns void
    */
    DetailSearchSubmitController.prototype.changedValue = function (source) {
        var src = source + '_filter';
        this[src].calculated = false;
    };
    /**
     * Will create unique items for the filters in the table
     * @param source       original or results
     * @returns void
     */
    DetailSearchSubmitController.prototype.makeFilterOptions = function (source, reset) {
        var _this = this;
        if (reset === void 0) { reset = false; }
        var src = source + '_filter';
        var srcArr = source + '_array';
        //if (this.filterObject.notEmpty) {
        if (!this[src].calculated && this[src].notEmpty) {
            //browse through every item in table
            this[src].calculated = true;
            if (reset) {
                for (var prop in this[src].filters) {
                    this[src].filters[prop].unique = [];
                }
            }
            angular.forEach(this[srcArr], function (tableLine) {
                //if the item is unique, put it into the representing unique value
                for (var prop in _this[src].filters) {
                    if (_this[src].filters[prop].type === 's') {
                        if (_this[src].filters[prop].unique.indexOf(tableLine[prop]) < 0) {
                            _this[src].filters[prop].unique.push(tableLine[prop]);
                        }
                    }
                }
            });
        }
    };
    /**
     Opens the dropdown with the filters. By changing this, we'll change the limitTo of the filter ng-repeat. This is done for
     performance increase(So DOM doenst have to have in special cases 4k+ checkboxes)
     @param source    original or results
     @param id        id of the filter
     @param size      size of the filter
     @returns void
    */
    DetailSearchSubmitController.prototype.openDrop = function (source, id, size) {
        var srcDrop = source + '_countDrop';
        this[srcDrop][id] = size;
    };
    /**
     Closes dropdown and sets the limitTo on the filter to 0
     @param source    original or results
     @param id        id of the filter
     @returns void
    */
    DetailSearchSubmitController.prototype.closeDrop = function (source, id) {
        var srcDrop = source + '_countDrop';
        this[srcDrop][id] = 0;
        this.blurFilterPick(source);
    };
    DetailSearchSubmitController.prototype.applySearchTxtFilter = function (source) {
        this.blurFilterPick(source);
    };
    /**
     * Based on the filters selected, only those lines in table are picked, that fullfill the picked filter values
     * @param source    original or results
     * @returns void
     */
    DetailSearchSubmitController.prototype.blurFilterPick = function (source) {
        var src = source + '_filter';
        var srcArr = source + '_array';
        var srcFilterObj = this[src];
        if (!srcFilterObj.calculated && srcFilterObj.notEmpty && Array.isArray(this.searchSubmit[source].table)) {
            var searchSubmitScrTable = this.searchSubmit.type === 'dc_v5' ?
                this.extractDcV5(this.searchSubmit[source].table) :
                this.searchSubmit[source].table;
            var tempArray_1;
            var tmpSearchTxt_1 = " " + String(srcFilterObj.searchTxt).toLocaleLowerCase().trim() + " ";
            var checkCellValueFn_1 = function (val) { return (" " + String(val).toLocaleLowerCase() + " ").indexOf(tmpSearchTxt_1) !== -1; };
            if (srcFilterObj.searchTxt) {
                var rowPassedBySearchTxtFilter_1;
                tempArray_1 = [];
                searchSubmitScrTable.forEach(function (row) {
                    rowPassedBySearchTxtFilter_1 = Object.keys(row).filter(function (cellKey) { return checkCellValueFn_1(row[cellKey]); }).length > 0;
                    if (rowPassedBySearchTxtFilter_1) {
                        tempArray_1.push(row);
                    }
                });
                searchSubmitScrTable = tempArray_1.slice();
                this[srcArr] = tempArray_1.slice();
            }
            // console.log('blurFilterPick');
            this.makeFilterOptions(source, true);
            this.original_filter.calculated = false;
            this.results_filter.calculated = false;
            var filterOK_1;
            tempArray_1 = [];
            angular.forEach(searchSubmitScrTable, function (tableLine) {
                filterOK_1 = true;
                var _loop_2 = function(prop) {
                    if (srcFilterObj.filters[prop].type === 's' && filterOK_1) {
                        if (srcFilterObj.filters[prop].picked.length > 0) {
                            filterOK_1 = false;
                            angular.forEach(srcFilterObj.filters[prop].picked, function (picked) {
                                if (picked === tableLine[prop]) {
                                    filterOK_1 = true;
                                }
                            });
                        }
                    }
                };
                for (var prop in srcFilterObj.filters) {
                    _loop_2(prop);
                }
                if (filterOK_1) {
                    tempArray_1.push(tableLine);
                }
            });
            this[srcArr] = angular.copy(tempArray_1);
        }
    };
    DetailSearchSubmitController.prototype.finishUp = function () {
        //Since this could be fired from Elig or Validation...need to determine where to go
        var tabby = 'eligibility';
        if (this.searchSubmit.type === 'cmr_valid') {
            tabby = 'validation';
        }
        this.$state.go('detail.' + tabby, {
            id: this.id
        });
        this.topic.setActiveTab(tabby);
    };
    DetailSearchSubmitController.prototype.findCriteria = function (key) {
        var criteria = this.searchSubmit.original.searchCriteria.filter(function (criteria) { return criteria.k === key; })[0];
        if (!criteria) {
            return null;
        }
        return criteria;
    };
    DetailSearchSubmitController.prototype.getCriteriaValueByKey = function (key) {
        var criteria = this.findCriteria(key);
        if (!criteria) {
            return '';
        }
        return criteria.v;
    };
    DetailSearchSubmitController.prototype.getCountryByCode = function (code) {
        var countries = this.settings.country_list;
        var countryObj = _.find(countries, { cc: code });
        if (!countryObj) {
            return null;
        }
        return countryObj;
    };
    DetailSearchSubmitController.prototype.getCountryFieldValue = function () {
        var value = this.getCriteriaValueByKey('Customer Country Landed') || this.getCriteriaValueByKey('Country Selected');
        return value;
    };
    DetailSearchSubmitController.prototype.shouldDisplayIssuingCountry = function () {
        var criteria = this.findCriteria('CMR Issuing Country');
        return !!criteria;
    };
    DetailSearchSubmitController.prototype.getIssuingCountryValue = function () {
        var _this = this;
        var countryCodeObj = this.getCriteriaValueByKey('CMR Issuing Country')[0];
        if (countryCodeObj) {
            var countries = _.isArray(countryCodeObj) ? countryCodeObj.map(function (code) { return _this.getCountryByCode(code); }) : [this.getCountryByCode(countryCodeObj)];
            var shorts = countries.map(function (country) { return country.short; });
            return shorts;
        }
        return '';
    };
    DetailSearchSubmitController.$inject = ['topic', '$state', '$stateParams', 'env', 'searchSubmit', 'notify', 'socket', 'settings', '$timeout', '$http', 'moment'];
    return DetailSearchSubmitController;
}());
var DetailSearchSubmitComponent = (function () {
    function DetailSearchSubmitComponent() {
        this.templateUrl = 'detail-search-submit.html';
        this.controllerAs = 'vm';
        this.controller = DetailSearchSubmitController;
    }
    return DetailSearchSubmitComponent;
}());
angular
    .module('application')
    .component('searchSubmitSection', new DetailSearchSubmitComponent());

//# sourceMappingURL=detail.search.submit.component.js.map
